/**
 * Decode JWT token and extract claims
 */
export function decodeJWT(token: string) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.warn('[JWT] Invalid token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Handle UTF-8 properly - atob gives us Latin1, need to convert to UTF-8
    const decoded = JSON.parse(decodeURIComponent(atob(payload).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')));
    return decoded;
  } catch (error) {
    console.error('[JWT] Failed to decode token:', error);
    return null;
  }
}

/**
 * Extract user claims from JWT token
 */
export function extractUserFromToken(token: string) {
  const decoded = decodeJWT(token);
  if (!decoded) return null;

  return {
    userId: decoded.UserId,
    username: decoded.UserName,
    displayName: decoded.UserNameAR || decoded.UserName,
    accountType: decoded.AccountType,
  };
}

/** Which portal a token belongs to. Staff ("User") and unknown tokens have no portal, so they get null. */
export function roleFromToken(token: string | null): 'customer' | 'doctor' | null {
  if (!token) return null;
  const type = String(decodeJWT(token)?.AccountType ?? '').toLowerCase();
  return type === 'doctor' ? 'doctor' : type === 'customer' ? 'customer' : null;
}
